<template>
  <div class="kefu-container desktop-container desktop-container-with-tabbar">

    <div class="service-intro-card">
        <div class="intro-content">
            <div class="intro-header">
                <div class="service-logo">
                    <div class="logo-rings">
                        <div class="ring ring-1"></div>
                        <div class="ring ring-2"></div>
                    </div>
                    <div class="logo-center"><span class="service-icon">💬</span></div>
                </div>
                <div class="intro-title">{{ t('kefu.title') }}</div>
            </div>
            <div class="intro-text">{{ t('kefu.intro.line1') }}</div>
            <div class="intro-text">{{ t('kefu.intro.line2') }}</div>
        </div>
        <div class="intro-bg-effect"></div>
    </div>


    <div class="service-time-card">
        <div class="time-content">
            <div class="time-icon"><span class="clock-icon">🕐</span></div>
            <div class="time-info">
                <div class="time-label">{{ t('kefu.serviceTime.label') }}</div>
                <div class="time-text">{{ t('kefu.serviceTime.text') }}</div>
            </div>
            <div class="time-status">
                <div class="status-dot"></div><span class="status-text">{{ t('kefu.serviceTime.online') }}</span></div>
        </div>
    </div>



    <div class="contact-section">
        <div class="section-title"><span class="title-icon">💬</span><span class="title-text">{{ t('kefu.contact.title') }}</span></div>
        <div class="contact-list">
            <div class="contact-item">
                <div class="contact-avatar"><img src="@/assets/static/kefu.jpg" alt="">
                    <div class="avatar-status"></div>
                </div>
                <div class="contact-info">
                    <div class="contact-name">{{ t('kefu.contact.name') }}</div>
                    <div class="contact-status">{{ t('kefu.contact.status') }}</div>
                    <div class="contact-features">
                        <div class="feature-tag">{{ t('kefu.contact.feature1') }}</div>
                        <div class="feature-tag">{{ t('kefu.contact.feature2') }}</div>
                    </div>
                </div>
                <div class="contact-action">
                    <div class="action-button" @click="handleContactClick"><span class="action-text">{{ t('kefu.contact.button') }}</span></div>
                </div>
            </div>
        </div>
    </div>

    <div class="faq-section">
      <div class="section-title">
        <span class="title-icon">❓</span>
        <span class="title-text">{{ t('kefu.faq.title') }}</span>
      </div>
      <div class="faq-container">
        <el-collapse v-model="activeNames">
          <el-collapse-item
            v-for="item in faqList"
            :key="item.name"
            :name="item.name"
          >
            <template #title>
              {{ t(item.question) }}
            </template>
            <div class="faq-answer">
              {{ formatAnswer(item.answer) }}
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
  </div>
</template>


<script setup>
import { ref, computed, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import { appConfig } from '@/config/app'
import { getServiceData } from '@/api'
import '@/assets/css/kefu.css'

const { t } = useI18n()
const router = useRouter()

const activeNames = ref([])

const serviceData = ref()

const fetchServiceData = async () => {
  try {
    const response = await getServiceData()
    if (response.data.code === 200) {
      serviceData.value = {
        url: response.data.data.url,
      }
    }
  } catch (error) {
    console.error('获取客服数据失败:', error)
  }
}

const handleContactClick = () => {
  if (serviceData.value.url) {
    window.open(serviceData.value.url, '_blank')
  }
}

onMounted(() => {
  fetchServiceData()
})

const faqList = ref([
  {
    name: '1',
    question: 'kefu.faq.rechargeQuestion',
    answer: 'kefu.faq.rechargeAnswer'
  },
  {
    name: '2',
    question: 'kefu.faq.withdrawQuestion',
    answer: 'kefu.faq.withdrawAnswer'
  },
  {
    name: '3',
    question: 'kefu.faq.minRechargeQuestion',
    answer: 'kefu.faq.minRechargeAnswer'
  },
  {
    name: '4',
    question: 'kefu.faq.withdrawTimeQuestion',
    answer: 'kefu.faq.withdrawTimeAnswer'
  },
  {
    name: '5',
    question: 'kefu.faq.securityQuestion',
    answer: 'kefu.faq.securityAnswer'
  }
])

const formatAnswer = (answerKey) => {
  return t(answerKey).replace(/\$\{currency\}/g, appConfig.currency.symbol)
}

</script>



